import styled from 'styled-components'

import { pulseAnimate } from '~/styles/shared/pulseAnimate'

import { HeightClass } from '~/utils/enum/classes'

import { ImpactClass, TextColor } from '../Button/types'

import { SyntheticButtonProps } from './types'

type ContainerProps = Pick<SyntheticButtonProps, 'pulseAnimate'> & {
  heightClass: HeightClass
  impactClass: ImpactClass
  textColor: TextColor
}

export const SyntheticButtonContainer = styled.div<ContainerProps>`
  position: relative;
  display: flex;
  align-items: center;

  height: auto;
  min-height: ${({ theme, heightClass }) => theme.button.heights[heightClass]};

  width: 100%;

  > button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  > div {
    height: 100%;

    > button {
      height: 100%;
    }
  }

  ul {
    z-index: 1;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    margin: 0;
    padding: 0;
    width: 100%;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-16px);
    transition: all 300ms;

    > li {
      list-style: none;
      margin-top: 2px;

      > button {
        padding-right: ${({ theme, heightClass }) =>
          theme.button.dropdownWidths[heightClass]};
      }
    }
  }

  [aria-expanded] {
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    width: ${({ theme, heightClass }) =>
      theme.button.dropdownWidths[heightClass]};

    padding: 0;

    > :first-child {
      transition: transform 300ms;
      transform: rotate(0);
    }
  }

  [aria-expanded='true'] {
    > :first-child {
      transform: rotate(-180deg);
    }

    & + ul {
      display: flex;
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }

  ${({ pulseAnimate: mode, theme, textColor, impactClass }) =>
    mode &&
    pulseAnimate(
      mode,
      theme.button.textColors?.[textColor].impactClasses[impactClass],
      '0px'
    )}

  border-radius: ${({ theme, heightClass }) =>
    theme.button.borderRadius?.[heightClass]};
`
